// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608141334/js/" + chunkId + "." + {"44":"c347d615","225":"0f0ed1a4","481":"6a3b3bbe","486":"35ca15bb","770":"1c0f870a"}[chunkId] + ".0.41994652829427437.chunk.js";
};